import React, {useState} from 'react';
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Paginator} from "primereact/paginator";
import {webInfo} from "../../../utils/webInfo";
import {Button} from "primereact/button";
import {catchError} from "../../../utils/helper";
import {Skeleton} from "primereact/skeleton";
import {InputSwitch} from "primereact/inputswitch";
import usePost from "../../../hooks/usePost";


const AnimalTable = ({products,total,selectedDepot,onPageChange,page,perPage,update,setUpdate}:any) => {
    const {post, loading: ploading} = usePost()
    const [expandedRows, setExpandedRows] = useState<any>(null);
    const actionTemplate = (rowData: any) => (
        <div className="flex gap-2 justify-content-center">
            <Button
                icon="pi pi-pencil"
                title="Edit"
                className="p-button-sm"
                onClick={() => console.log("Details:", rowData)}
            />
            <Button
                icon="pi pi-trash"
                title="Remove"
                disabled
                className="p-button-sm p-button-danger"
                onClick={() => console.log("Remove:", rowData.id)}
            />
        </div>
    );
    const imageTemplate = (rowData:any) => (
        <img
            src={`${webInfo.baseUrl}/${rowData.image}`}
            alt={rowData.name}
            style={{ width: "20px", borderRadius: "6px" }}
        />
    );

    const divisionBodyTemplate = ()=>(
        <span>{selectedDepot.name}</span>
    )


    const rowExpansionTemplate = (data: any) => {
        const publishStatus = (rowData: any) => {
            const statusUpdateUrl = `${webInfo.baseUrl}/api/admin/products-animal-sub-category/${rowData?.id}/publish-status`
            const updateStatus = async (rowData: any) => {
                const payload = {
                    status: Number(rowData.status) === 1 ? 0 : 1,
                }
                try {
                    const res: any = await post(statusUpdateUrl, true, payload)
                    if (res.success) {
                        setUpdate(!update);
                    }
                } catch (e) {
                    catchError(e)
                }
            }

            if (ploading) {
                return <Skeleton width={"4rem"} height={"2.5rem"}></Skeleton>
            }
            return <div className="flex gap-2 justify-content-start">
                <InputSwitch checked={Number(rowData?.status) === 1} onChange={() => updateStatus(rowData)}/>
            </div>
        }
        return (
            <div>
                <h5>Sub Categories</h5>
                <DataTable
                    value={data?.sub_categories}
                    rows={5}
                    stripedRows
                >
                    <Column field="name" header="Name" sortable />
                    <Column
                        header="Status"
                        body={publishStatus}
                        style={{ width: "120px", textAlign: "center" }}
                    />
                </DataTable>
            </div>
        );
    };

    const publishStatus = (rowData: any) => {
        const statusUpdateUrl = `${webInfo.baseUrl}/api/admin/products-animal-category/${rowData?.id}/publish-status`
        const updateStatus = async (rowData: any) => {
            const payload = {
                status: Number(rowData.status) === 1 ? 0 : 1,
            }
            try {
                const res: any = await post(statusUpdateUrl, true, payload)
                if (res.success) {
                    setUpdate(!update);
                }
            } catch (e) {
                catchError(e)
            }
        }

        if (ploading) {
            return <Skeleton width={"4rem"} height={"2.5rem"}></Skeleton>
        }
        return <div className="flex gap-2 justify-content-start">
            <InputSwitch checked={Number(rowData?.status) === 1} onChange={() => updateStatus(rowData)}/>
        </div>
    }
    return (
        <div>
            <DataTable
                value={products}
                rows={5}
                stripedRows
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
            >
                <Column expander={true} style={{width: '5rem'}}/>
                <Column
                    header="Image"
                    body={imageTemplate}
                    style={{ width: "100px", textAlign: "center" }}
                />
                <Column field="name" header="Category Name" sortable />
                <Column field="products_count" header="Total Products" sortable />
                <Column
                    header="Status"
                    body={publishStatus}
                    style={{ width: "120px", textAlign: "center" }}
                />
                <Column body={divisionBodyTemplate} header="Division" sortable />
                <Column
                    header="Actions"
                    body={actionTemplate}
                    style={{ width: "120px", textAlign: "center" }}
                />
            </DataTable>
            <Paginator
                first={(page - 1) * perPage}
                rows={perPage}
                totalRecords={total}
                rowsPerPageOptions={[10, 20, 30]}
                onPageChange={onPageChange}
            />
        </div>
    );
};

export default AnimalTable;